import { createAction, props } from '@ngrx/store';
import { ITrade, ITransaction } from '@shared/models';

export enum ActionTypes {
  Load                = '[Trade] Load',
  LoadSuccess         = '[Trade] Load Success',
  Clear               = '[Trade] Clear',
  Cancel              = '[Trade] Cancel',
  Approve             = '[Trade] Approve',
  End                 = '[Trade] End',
  UpdateBlockBalance  = '[Trade] Update Block Balance',
  Decline             = '[Trade] Decline',
  Finalize            = '[Trade] Finalize',
  Remove              = '[Trade] Remove'
}

export const load = createAction(
  ActionTypes.Load,
  props<{ id: number }>()
);

export const loadSuccess = createAction(
  ActionTypes.LoadSuccess,
  props<{ trade: ITrade }>()
  );

export const clear = createAction(
  ActionTypes.Clear
);

export const cancel = createAction(
  ActionTypes.Cancel,
  props<{ id: number }>()
);

export const approve = createAction(
  ActionTypes.Approve,
  props<{ id: number }>()
);

export const end = createAction(
  ActionTypes.End,
  props<{ id: number }>()
);

export const updateBlockBalance = createAction(
  ActionTypes.UpdateBlockBalance,
  props<{ transaction: ITransaction }>()
);

export const decline = createAction(
  ActionTypes.Decline,
  props<{ id: number }>()
);

export const finalize = createAction(
  ActionTypes.Finalize,
  props<{ id: number, userIds: number[] }>()
);

export const remove = createAction(
  ActionTypes.Remove,
  props<{ id: number }>()
);
